/**
* @Author: zachalam
* @Date:   2017-01-19T16:33:10-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T16:57:12-08:00
*/

import React, { Component } from 'react';
import Settings from '../components/pages/Settings/Settings';
import { connect } from 'react-redux';
import { getProfileSettings, invertSetting,
  updateProfileSetting, updatePassword, updateEmail, refreshAccount } from '../actions/profileActions';
import { getRecentSubscription, deleteActiveSubscription } from '../actions/billingActions';

class SettingsContainer extends Component {

  componentWillMount() {
    // refresh data on new page
    this.props.refresh();
  }

  render() {
    return (
      <Settings {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subscription: state.billing.subscription,
    settings: state.settings,
    errors: state.common.errors,
    isFemale: Boolean(state.profile.profile.data.sex === "Female")
  }
};

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    refresh: () => {
      // get profile settings and blocked list.
      dispatch(getProfileSettings());
      dispatch(getRecentSubscription());
      // also refresh account (for header counts).
      dispatch(refreshAccount());
    },
    updatePasswordForm: (formData, callback) => {
      // update password on file. (in API)
      dispatch(updatePassword(formData))
              .then(() => { callback(); });
    },
    updateEmailForm: (formData, callback) => {
      // update email address (in API)
      dispatch(updateEmail(formData))
              .then(() => { callback(); });
    },
    updateAccountSetting: (e) => {
      // update specific account setting (in redux) - set to opposite val
      dispatch(invertSetting(e.target.id));
      // also notify API of change.
      dispatch(updateProfileSetting());

    },
    confirmCancel: () => {
      // handles the canceling of a subscription.
      dispatch(deleteActiveSubscription());
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(SettingsContainer);



// WEBPACK FOOTER //
// ./src/containers/SettingsContainer.jsx